import { API_BASE_URL } from "../constants/Constants";
import { resolveBackendForHost } from "./DomainConfigHelper";

const DEFAULT_BRAND = "DeepTek";
// An empty data URL stops the browser from falling back to /favicon.ico
// (which is the DeepTek icon), so it shows its own blank default icon.
const BLANK_FAVICON = "data:,";

// Tab title for a page:
//   not rebranded            → "<page> (DeepTek)"   (unchanged)
//   rebranded, no tabTitle   → "<page>"             (default rebranding)
//   rebranded, tabTitle set  → "<page> (<tabTitle>)"
export const getBrandedTitle = (pageTitle) => {
  const { matched, tabTitle } = resolveBackendForHost(window.location.host);
  const brand = matched ? tabTitle : DEFAULT_BRAND;
  return brand ? `${pageTitle} (${brand})` : pageTitle;
};

const setFavicon = (href) => {
  document.querySelectorAll("link[rel~='icon']").forEach((el) => el.remove());
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = href;
  document.head.appendChild(link);
};

// Applies the per-domain base tab title and favicon. Non-rebranded domains are
// left exactly as index.html defines them.
export const applyBranding = () => {
  const { matched, tabTitle } = resolveBackendForHost(window.location.host);
  if (!matched) return;

  if (tabTitle) document.title = tabTitle;

  // Hide the DeepTek icon straight away, then swap in the tenant's favicon only
  // if the backend actually has one (it answers 204 when it doesn't).
  setFavicon(BLANK_FAVICON);
  const faviconUrl = `${API_BASE_URL}rebranding/favicon?host=${encodeURIComponent(window.location.host)}`;
  const probe = new Image();
  probe.onload = () => setFavicon(faviconUrl);
  probe.src = faviconUrl;
};
